import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { formatString } from 'src/util/STR';
import { baseQueryISF } from './baseQueryISF';

export const isfDocLevelApi = createApi({
  baseQuery: baseQueryISF,
  reducerPath: 'isfDocLevelApi',
  endpoints: builder => ({
    getAllDocumentsByMilestonenameSiteLevelISF: builder.query<any, any>({
      query: ({
        site_id,
        study_id,
        country,
        application,
        milestone,
        module_section_related,
        parent_entity_related,
        originally_uploaded,
        user_based_details
      }) => ({
        url: `${endPoints.ISFApis.getAllIsfDocsByArtifcatNumberSitelevel}?country_id=${country}&site_id=${site_id}&study_id=${study_id}&is_binder_view=false&isf_doc_milestone=${milestone}&isf_doc_level=Site&user_based_details=${user_based_details}&limit=200&application=${application}&originally_uploaded=${originally_uploaded}&module_section_related=${module_section_related}&parent_entity_related=${parent_entity_related}`,
        method: 'GET'
      })
    }),
    getISFDocInfoByLevelTypeArtifactName: builder.query<any, any>({
      query: ({
        level_type,
        site_id,
        study_id,
        country,
        artifactName,
        module_section_related,
        parent_entity_related
      }) => ({
        url: `${formatString(endPoints.ISFApis.selectIsfDocInfoByLevelAndName, {
          key: urlKeys.level_type,
          value: level_type
        })}?site_id=${site_id}&study_id=${study_id}&country_id=${country}&isf_artifact_name=${artifactName}&module_section_related=${module_section_related}&parent_entity_related=${parent_entity_related}`,
        method: 'GET'
      })
    }),
    getAllISFDocInfoByArtifactNumberSiteLevel: builder.query<any, any>({
      query: ({
        site_id,
        study_id,
        country,
        artifactName,
        artifactNumber,
        originally_uploaded,
        application,
        module_section_related,
        parent_entity_related
      }) => ({
        url: `${formatString(
          endPoints.ISFApis.getAllIsfDocsByArtifcatNumberSitelevel
        )}?site_id=${site_id}&study_id=${study_id}&country_id=${country}&is_binder_view=false&isf_artifact_name=${artifactName}&limit=5000${
          artifactNumber != null ? `&isf_artifact_number=${artifactNumber}` : ''
        }&application=${application}&originally_uploaded=${originally_uploaded}&user_based_details=false&module_section_related=${module_section_related}&parent_entity_related=${parent_entity_related}`,
        method: 'GET'
      })
    }),
    uploadMasterIsfFile: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, application, module_section_related, parent_entity_related }) => ({
        url: `${formatString(
          endPoints.ISFApis.uploadIsfFile
        )}?site_id=${site_id}&study_id=${study_id}&country_id=${country}&application=${application}&module_section_related=${module_section_related}&parent_entity_related=${parent_entity_related}`,
        method: 'POST',
        headers: { 'Content-Type': 'multipart/form-data' },
        body: data
      })
    }),
    createMasterDocIsf: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, application, module_section_related, parent_entity_related }) => ({
        url: `${formatString(
          endPoints.ISFApis.createMasterDoc
        )}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=${application}&module_section_related=${module_section_related}&parent_entity_related=${parent_entity_related}`,
        method: 'POST',
        body: data
      })
    }),
    deleteIsfDocByFileId: builder.mutation<any, any>({
      query: ({
        site_id,
        study_id,
        country,
        application,
        file_master_id,
        module_section_related,
        parent_entity_related
      }) => ({
        url: `${formatString(endPoints.ISFApis.deleteIsfDocByFileMasterId, {
          key: urlKeys.file_master_id,
          value: file_master_id
        })}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=${application}&module_section_related=${module_section_related}&parent_entity_related=${parent_entity_related}`,
        method: 'PATCH'
      })
    }),
    deleteAllIsfDocsByFileIds: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, application, data, module_section_related, parent_entity_related }) => ({
        url: `${formatString(
          endPoints.ISFApis.deleteAllIsfDocsByFileMasterIds
        )}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=${application}&module_section_related=${module_section_related}&parent_entity_related=${parent_entity_related}`,
        method: 'PATCH',
        body: data
      })
    }),
    getISFDocDetailsByStudyDocumentId: builder.query<any, any>({
      query: ({
        site_id,
        study_id,
        country,
        documentId,
        application,
        module_section_related,
        parent_entity_related
      }) => ({
        url: `${formatString(endPoints.ISFApis.getIsfDocDetailsByStudyDocId, {
          key: urlKeys.study_id,
          value: study_id
        })}?site_id=${site_id}&country_id=${country}&document_id=${documentId}&application=${application}&module_section_related=${module_section_related}&parent_entity_related=${parent_entity_related}`,
        method: 'GET'
      })
    }),
    getISFDocDetailsByIsfDocumentId: builder.query<any, any>({
      query: ({
        site_id,
        study_id,
        country,
        isfDocumentId,
        application,
        module_section_related,
        parent_entity_related
      }) => ({
        url: `${formatString(endPoints.ISFApis.getIsfDocDetailsByStudyDocId, {
          key: urlKeys.study_id,
          value: study_id
        })}?site_id=${site_id}&country_id=${country}&isf_document_id=${isfDocumentId}&application=${application}&module_section_related=${module_section_related}&parent_entity_related=${parent_entity_related}`,
        method: 'GET'
      })
    }),
    updateInlineMaterDocIsf: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, application, module_section_related, parent_entity_related }) => ({
        url: `${formatString(
          endPoints.ISFApis.updateInlineMasterDoc
        )}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=${application}&module_section_related=${module_section_related}&parent_entity_related=${parent_entity_related}`,
        method: 'PUT',
        body: data
      })
    })
  })
});

export const {
  useLazyGetAllDocumentsByMilestonenameSiteLevelISFQuery,
  useLazyGetISFDocInfoByLevelTypeArtifactNameQuery,
  useLazyGetAllISFDocInfoByArtifactNumberSiteLevelQuery,
  useUploadMasterIsfFileMutation,
  useCreateMasterDocIsfMutation,
  useDeleteIsfDocByFileIdMutation,
  useLazyGetISFDocDetailsByStudyDocumentIdQuery,
  useLazyGetISFDocDetailsByIsfDocumentIdQuery,
  useUpdateInlineMaterDocIsfMutation,
  useDeleteAllIsfDocsByFileIdsMutation
} = isfDocLevelApi;
